import { Injectable, Inject } from '@angular/core';
import { Medium } from '@ridango/core';
import { HttpClient } from '@angular/common/http';
import { NgRedux } from '@angular-redux/store';
import { MediumState } from './store/medium.store';
import { MediumActions } from './+state/medium.actions';

@Injectable({
    providedIn: 'root',
})
export class MediumService {
    constructor(
        @Inject('ENV') private env: any,
        private http: HttpClient,
        private ngRedux: NgRedux<MediumState>,
        private actions: MediumActions
    ) {}

    setSelectedMedium(medium: Medium) {
        this.ngRedux.dispatch(this.actions.setSelectedMedium(medium));
    }
}
